import { Outlet } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';

export function AuthLayout() {
  const { isDark } = useTheme();

  return (
    <div
      className="b2b min-h-[100dvh] flex items-center justify-center p-4 safe-area-inset-top safe-area-inset-bottom safe-area-inset-x"
      data-theme={isDark ? 'dark' : 'light'}
    >
      <div className="w-full max-w-lg">
        <Outlet />
      </div>
    </div>
  );
}
